export const SUPPORT_PHONE_NUMBER = '+1 (978) 435-2030';
export const QUANTERIX_TECH_EMAIL = 'techsupport@quanterix.com';
